<template>
  <svg
    v-if="status === 'success'"
    :width="sizeValue"
    :height="sizeValue"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.13831 12.6389L13.4265 7.35071L12.3763 6.30058L8.13831 10.5386L6.00054 8.40084L4.95041 9.45097L8.13831 12.6389ZM9.18844 16.6894C8.15081 16.6894 7.17569 16.4925 6.26307 16.0987C5.35046 15.7049 4.55661 15.1704 3.88152 14.4954C3.20644 13.8203 2.672 13.0264 2.2782 12.1138C1.8844 11.2012 1.6875 10.2261 1.6875 9.18844C1.6875 8.15081 1.8844 7.17569 2.2782 6.26307C2.672 5.35046 3.20644 4.55661 3.88152 3.88152C4.55661 3.20644 5.35046 2.672 6.26307 2.2782C7.17569 1.8844 8.15081 1.6875 9.18844 1.6875C10.2261 1.6875 11.2012 1.8844 12.1138 2.2782C13.0264 2.672 13.8203 3.20644 14.4954 3.88152C15.1704 4.55661 15.7049 5.35046 16.0987 6.26307C16.4925 7.17569 16.6894 8.15081 16.6894 9.18844C16.6894 10.2261 16.4925 11.2012 16.0987 12.1138C15.7049 13.0264 15.1704 13.8203 14.4954 14.4954C13.8203 15.1704 13.0264 15.7049 12.1138 16.0987C11.2012 16.4925 10.2261 16.6894 9.18844 16.6894Z" :fill="colors" />
  </svg>

  <svg
    v-else-if="status === 'error'"
    :width="sizeValue"
    :height="sizeValue"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.8 11.25L7.5 8.55L10.2 11.25L11.25 10.2L8.55 7.5L11.25 4.8L10.2 3.75L7.5 6.45L4.8 3.75L3.75 4.8L6.45 7.5L3.75 10.2L4.8 11.25ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4813 2.19375 12.8063C1.51875 12.1313 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1313 1.51875 12.8063 2.19375C13.4813 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4813 12.1313 12.8063 12.8063C12.1313 13.4813 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15Z" :fill="colors" />
  </svg>

  <svg
    v-else-if="status === 'error-outlined'"
    :width="sizeValue"
    :height="sizeValue"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.73333 8.75L5.83333 6.65L7.93333 8.75L8.75 7.93333L6.65 5.83333L8.75 3.73333L7.93333 2.91667L5.83333 5.01667L3.73333 2.91667L2.91667 3.73333L5.01667 5.83333L2.91667 7.93333L3.73333 8.75ZM5.83333 11.6667C5.02639 11.6667 4.26806 11.5135 3.55833 11.2073C2.84861 10.901 2.23125 10.4854 1.70625 9.96042C1.18125 9.43542 0.765625 8.81806 0.459375 8.10833C0.153125 7.39861 0 6.64028 0 5.83333C0 5.02639 0.153125 4.26806 0.459375 3.55833C0.765625 2.84861 1.18125 2.23125 1.70625 1.70625C2.23125 1.18125 2.84861 0.765625 3.55833 0.459375C4.26806 0.153125 5.02639 0 5.83333 0C6.64028 0 7.39861 0.153125 8.10833 0.459375C8.81806 0.765625 9.43542 1.18125 9.96042 1.70625C10.4854 2.23125 10.901 2.84861 11.2073 3.55833C11.5135 4.26806 11.6667 5.02639 11.6667 5.83333C11.6667 6.64028 11.5135 7.39861 11.2073 8.10833C10.901 8.81806 10.4854 9.43542 9.96042 9.96042C9.43542 10.4854 8.81806 10.901 8.10833 11.2073C7.39861 11.5135 6.64028 11.6667 5.83333 11.6667ZM5.83333 10.5C7.13611 10.5 8.23958 10.0479 9.14375 9.14375C10.0479 8.23958 10.5 7.13611 10.5 5.83333C10.5 4.53056 10.0479 3.42708 9.14375 2.52292C8.23958 1.61875 7.13611 1.16667 5.83333 1.16667C4.53056 1.16667 3.42708 1.61875 2.52292 2.52292C1.61875 3.42708 1.16667 4.53056 1.16667 5.83333C1.16667 7.13611 1.61875 8.23958 2.52292 9.14375C3.42708 10.0479 4.53056 10.5 5.83333 10.5Z" :fill="colors" />
  </svg>

  <svg
    v-else-if="status === 'danger'"
    :width="sizeValue"
    :height="sizeValue"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.0013 15.0019C10.2846 15.0019 10.5221 14.906 10.7138 14.7143C10.9055 14.5226 11.0014 14.2851 11.0014 14.0018C11.0014 13.7184 10.9055 13.4809 10.7138 13.2892C10.5221 13.0975 10.2846 13.0016 10.0013 13.0016C9.71788 13.0016 9.48035 13.0975 9.28866 13.2892C9.09697 13.4809 9.00113 13.7184 9.00113 14.0018C9.00113 14.2851 9.09697 14.5226 9.28866 14.7143C9.48035 14.906 9.71788 15.0019 10.0013 15.0019ZM9.00113 11.0014H11.0014V5.00063H9.00113V11.0014ZM10.0013 20.0025C8.61774 20.0025 7.31758 19.74 6.10076 19.2149C4.88394 18.6898 3.82548 17.9772 2.92537 17.0771C2.02525 16.177 1.31266 15.1186 0.787598 13.9017C0.262533 12.6849 0 11.3848 0 10.0013C0 8.61774 0.262533 7.31758 0.787598 6.10076C1.31266 4.88394 2.02525 3.82548 2.92537 2.92537C3.82548 2.02525 4.88394 1.31266 6.10076 0.787598C7.31758 0.262533 8.61774 0 10.0013 0C11.3848 0 12.6849 0.262533 13.9017 0.787598C15.1186 1.31266 16.177 2.02525 17.0771 2.92537C17.9772 3.82548 18.6898 4.88394 19.2149 6.10076C19.74 7.31758 20.0025 8.61774 20.0025 10.0013C20.0025 11.3848 19.74 12.6849 19.2149 13.9017C18.6898 15.1186 17.9772 16.177 17.0771 17.0771C16.177 17.9772 15.1186 18.6898 13.9017 19.2149C12.6849 19.74 11.3848 20.0025 10.0013 20.0025Z" :fill="colors" />
  </svg>

  <svg 
    v-else-if="status === 'info'"
    :width="sizeValue"
    :height="sizeValue"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.60108 14.6018L15.652 7.55094L14.2518 6.15077L8.60108 11.8015L5.75072 8.95112L4.35054 10.3513L8.60108 14.6018ZM10.0013 20.0025C8.61774 20.0025 7.31758 19.74 6.10076 19.2149C4.88394 18.6898 3.82548 17.9772 2.92537 17.0771C2.02525 16.177 1.31266 15.1186 0.787598 13.9017C0.262533 12.6849 0 11.3848 0 10.0013C0 8.61774 0.262533 7.31758 0.787598 6.10076C1.31266 4.88394 2.02525 3.82548 2.92537 2.92537C3.82548 2.02525 4.88394 1.31266 6.10076 0.787598C7.31758 0.262533 8.61774 0 10.0013 0C11.3848 0 12.6849 0.262533 13.9017 0.787598C15.1186 1.31266 16.177 2.02525 17.0771 2.92537C17.9772 3.82548 18.6898 4.88394 19.2149 6.10076C19.74 7.31758 20.0025 8.61774 20.0025 10.0013C20.0025 11.3848 19.74 12.6849 19.2149 13.9017C18.6898 15.1186 17.9772 16.177 17.0771 17.0771C16.177 17.9772 15.1186 18.6898 13.9017 19.2149C12.6849 19.74 11.3848 20.0025 10.0013 20.0025Z" fill="#175CD3"/>
  </svg>
</template>

<script>
export default {
  name: 'StatusIcon',
  props: {
    status: { type: String, default: 'success' },
    size: { type: String, default: undefined },
    color: { type: String, default: undefined }
  },
  computed: {
    sizeValue () {
      switch (this.size) {
        case 'small': return 12
        case 'medium': return 20
        case 'large': return 32
        default: return 16
      }
    },
    colors () {
      if (this.color !== undefined) return this.color
      if (this.status === 'success') return '#027A56'
      if (this.status === 'info') return '#1849A9'
      return '#B41818'
    }
  }
}
</script>
